import { Country } from "../../../types/common";
import type { TaskProps } from "../../../types/TaskProps";
import { formatAccountNumber } from "../../../utils/account.helper";

type FlowWithData = Pick<TaskProps["flow"], "data">;

/**
 * Priority: 1 - CustomerInformation (Get most recent account number from signing solution)
 * Priority: 2 - AgentApiApplication (From application form)
 */
export const getAccountNumberCommonProcess = (flow: FlowWithData) => {
  const state = flow?.data || {};
  const { disbursementAccountNumber } =
    state?.caseWork?.["manual-changed-values"] || {};

  if (disbursementAccountNumber) {
    return formatAccountNumber(disbursementAccountNumber, false, state.country);
  }

  const { LeaBankWeb, tink } = state.integrations || {};

  if (LeaBankWeb?.customerInformation?.accountNumber) {
    return LeaBankWeb.customerInformation.accountNumber;
  }

  // Finland pays out to the IBAN, which is what the Core mapper picks from the Tink account.
  // Comparing the local BBAN here would report a mismatch against the account actually used.
  if (state.country === Country.FI && tink?.applicant?.accounts?.[0]?.iban) {
    return tink.applicant.accounts[0].iban;
  }

  if (tink?.applicant?.accounts?.[0]?.accountNumber) {
    return tink.applicant.accounts[0].accountNumber;
  }

  return state.agentApiApplication?.application?.bankAccountNumber;
};

export const getAccountNumberEsProcess = (flow: FlowWithData) => {
  const { LeaBankWeb, openBankingPSD2 } = flow?.data?.integrations || {};
  if (LeaBankWeb?.customerInformation?.accountNumber) {
    return LeaBankWeb.customerInformation.accountNumber;
  }

  const { bankAccountNumber, applicant } =
    flow?.data?.agentApiApplication || {};
  if (bankAccountNumber) {
    return bankAccountNumber;
  }

  if (openBankingPSD2?.balance?.[0]?.accountId) {
    return openBankingPSD2.balance[0].accountId;
  }

  if (applicant?.psD2Data?.accounts?.[0]?.accountId) {
    return applicant.psD2Data.accounts[0].accountId;
  }

  return null;
};
